import { Injectable, Inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';

@Injectable({
    providedIn: 'root'
})
export class SignalrService {

    constructor(@Inject('BASE_URL') public baseUrl: string) { }

    private hubName: string;
    private handlerRegistration: (connection: signalR.HubConnection) => void
    private onConnectActions: (connection: signalR.HubConnection) => void
    private onConnectionClosed: () => void

    private setConnectionVariable: (connection: signalR.HubConnection) => void

    private connection: signalR.HubConnection;

    private disableReconnect = true;

    /**
     * Create SignalR connection
     * @param hubname name of the hub
     */
    public CreateConnnection(hubname: string): signalR.HubConnection {

        this.hubName = hubname;
        this.disableReconnect = false;

        // all transports as default
        let transports = signalR.HttpTransportType.None;




        // if using IE just use ServerSentEvents or LongPolling, otherwise use anything
        if (this.isMsie()) {

            transports = signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling;
        } else {

        }

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(hubname, {
                transport: transports,
                accessTokenFactory: () => {
                    // add the JWT token to signalR
                    const token = localStorage.getItem('jwt');
                    return token;
                }
            })
            .build();

        return connection;
    }

    private isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
    }



    /**
   * Create SignalR connection which will reconnect when connection lost
   * @param hubname Name of the hub
   * @param handlerRegistration Function which registers the connection On handlers
   * @param onConnectActions Function to be executed when the hub connects/reconnects
   */

    public async CreateConnnectionWithReconnect(hubname: string, handlerRegistration: (connection: signalR.HubConnection) => void, onConnectActions: (connection: signalR.HubConnection) => void, setConnectionVariable: (connection: signalR.HubConnection) => void): Promise<void> {
        await this.CreateConnnectionWithReconnectWithClose(hubname, handlerRegistration, onConnectActions, setConnectionVariable, null);
    }


    /**
     * Create SignalR connection which will reconnect when connection lost
     * @param hubname Name of the hub
     * @param handlerRegistration Function which registers the connection On handlers
     * @param onConnectActions Function to be executed when the hub connects/reconnects
     * @param onConnectionClosed Function to be executed when the hub microI disconnects
     */
    public async CreateConnnectionWithReconnectWithClose(hubname: string, handlerRegistration: (connection: signalR.HubConnection) => void, onConnectActions: (connection: signalR.HubConnection) => void, setConnectionVariable: (connection: signalR.HubConnection) => void, onConnectionClosed: () => void): Promise<void> {
        this.connection = this.CreateConnnection(hubname);

        this.handlerRegistration = handlerRegistration;
        this.onConnectActions = onConnectActions;
        this.onConnectionClosed = onConnectionClosed;
        this.setConnectionVariable = setConnectionVariable;

        this.setConnectionVariable(this.connection);

        this.handlerRegistration(this.connection);

        this.connection.onclose((err) => {

            if (this.onConnectionClosed) {
                this.onConnectionClosed();
            }

            //$('div.banner-hide').toggleClass('banner-hide banner-show');
            //$('#spnConnectionfailed').hide();

            this.reconfigureConnection();
        });

        await this.start(this.connection);
    }

    private async start(connection: signalR.HubConnection) {
        try {



            await connection.start();


            if (this.onConnectActions) {
                this.onConnectActions(connection);
            }
        } catch (err) {


            setTimeout(() => this.reconfigureConnection(), 5000);
        }
    }

    private reconfigureConnection() {
        if (this.disableReconnect) {
            return;
        }


        this.CreateConnnectionWithReconnectWithClose(this.hubName, this.handlerRegistration, this.onConnectActions, this.setConnectionVariable, this.onConnectionClosed);
    }

    public disconnect() {
        this.disableReconnect = true;
        if (this.connection) {
            this.connection.onclose(null);
            this.connection.stop();
        }
    }

    public reconnect() {
        this.disableReconnect = false;
        if (this.connection) {
            this.connection.onclose(null);
            this.connection.stop();
        }
    }
}
